module.exports = __webpack_public_path__ + "img/weddingRingsFacettedConnections-emotion-01@2x.99b548e.webp";